import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { OrderItem } from '../../models/order-item';
import { IconComponent } from '@softline/ui-core';

@Component({
  selector: 'soft-garage-order-item-card',
  imports: [IconComponent],
  templateUrl: './order-item-card.component.html',
  styleUrl: './order-item-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderItemCardComponent {
  orderItem = input.required<OrderItem>();
  editOrderItem = output();
  removeOrderItem = output();
  canEdit = input<boolean>(false);
  canDelete = input<boolean>(false);
}
